// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"SelectTags_tagsContainer__3kJga","tag":"SelectTags_tag__1WTmA","tagsHeader":"SelectTags_tagsHeader__32UlE"};